import { render, staticRenderFns } from "./BaseTradeInOptionGroup.vue?vue&type=template&id=00c54e25&scoped=true"
import script from "./BaseTradeInOptionGroup.vue?vue&type=script&lang=js"
export * from "./BaseTradeInOptionGroup.vue?vue&type=script&lang=js"
import style0 from "./BaseTradeInOptionGroup.vue?vue&type=style&index=0&id=00c54e25&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c54e25",
  null
  
)

export default component.exports